export default "__VITE_ASSET__Bp5GF9t7__"